/* src/app/modules/finanzas/paymentcard/paymentcard-form.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.pcf-page {
  min-width: 0;
  max-height: none;
  margin: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.pcf-header-text {
  min-width: 0;
  padding-right: 32px;
}
.pcf-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.pcf-row {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  gap: 0 16px;
}
.pcf-hint {
  margin: -8px 0 8px;
  font-size: 12px;
  color: #6b7280;
}
@media (max-width: 480px) {
  .pcf-row {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=paymentcard-form.component.css.map */
